import React from 'react';
import { Snackbar, Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

interface ToastProps {
  open: boolean;
  onClose: () => void;
  message: string;
  autoHideDuration?: number;
}

const Toast: React.FC<ToastProps> = ({
  open,
  onClose,
  message,
  autoHideDuration = 5000,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      data-testid="error-toast"
    >
      <Box
        role="alert"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
          backgroundColor: '#D40020',
          borderRadius: '4px',
          padding: '12px 16px',
          boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
        }}
      >
        <ErrorIcon sx={{ color: '#FFFFFF' }} />
        <Typography
          sx={{
            color: '#FFFFFF',
            fontFamily: 'Poppins',
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '21px',
          }}
        >
          {message}
        </Typography>
      </Box>
    </Snackbar>
  );
};

export default Toast;
